// extracted by mini-css-extract-plugin
export default {"box":"index_box_Ir5AX","exPlanWrapper":"index_exPlanWrapper_TOwsO"};